import c from "./constants";
import { setUserData } from "../user";
import { googleAuthService } from "./services";
import { route } from "preact-router";
import { PATH_DIARY } from "../../routes";

export function googleLogin(idToken) {
  const begin = () => ({ type: c.LOGIN_BEGIN });
  const success = user => ({ type: c.LOGIN_SUCCESS, payload: user });
  const failure = error => ({ type: c.LOGIN_FAILURE, payload: error });

  return async dispatch => {
    dispatch(begin());
    try {
      const data = await googleAuthService(idToken);
      dispatch(setUserData(data));
      dispatch(success(data));
      route(PATH_DIARY, true);
    } catch (error) {
      dispatch(failure(error.toString()));
    }
  };
}

export function googleLoginError(error) {
  const failure = error => ({ type: c.LOGIN_FAILURE, payload: error });

  return async dispatch => {
    dispatch(failure(error));
  };
}



// WEBPACK FOOTER //
// ./src/modules/login/actions.js